import "../../main";
import $ from 'jquery';
import { StringExtensions } from 'rustig';
import { ZoomLevel } from "../map/marker"
import { CountyOverlay } from "../map/countyoverlay"

export class Counties {
  map: google.maps.Map;
  overlay: CountyOverlay;

  public constructor(map: google.maps.Map) {
    this.map = map;

    $(document).on('toggle-county-lines', this.toggle.bind(this));
    let shouldShowCountyLines = StringExtensions.toBoolean($('[data-show-county-lines]').val() as string);
    $(document).trigger('toggle-county-lines', shouldShowCountyLines);
  }

  toggle(event: Event, shouldShowCountyLines: boolean): void {
    if (shouldShowCountyLines && this.overlay)
      this.overlay.enable();
    else if (shouldShowCountyLines) {
      this.overlay = new CountyOverlay(this.map, ZoomLevel.State, 2);
    }
    else if (this.overlay)
      this.overlay.disable();
  }
}